module.exports = __webpack_public_path__ + "img/jies.da5991d5.png";